import $ from 'jquery';
import Swiper from 'swiper';
import onDocumentReady from '../util/onDocumentReady';
import StoreService from '../service/StoreService';
import CatalogService from '../service/CatalogService';
import CatalogItem from '../template/CatalogItem';

const indexPopularSliders = [];

const createSlider = (tab) => {
    if (indexPopularSliders[tab] !== undefined) {
        return false;
    }
    indexPopularSliders[tab] = new Swiper(`.index-popular-tab--${tab} .swiper-container`, {
        speed: 600,
        spaceBetween: 20,
        slidesPerView: 5,
        slidesPerGroup: 5,
        // loop: true,
        autoHeight: false,
        pagination: {
            el: `.index-popular-tab--${tab} .index-popular-control__pagination`,
            type: 'fraction',
        },
        navigation: {
            nextEl: `.index-popular-tab--${tab} .index-popular-control__button--next`,
            prevEl: `.index-popular-tab--${tab} .index-popular-control__button--prev`,
        },

        breakpoints: {
            767: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            1023: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1439: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },
    });
    return true;
};

const refreshSlider = function (sliderInstance, productIds) {
    const params = {
        limit: 999,
        id: productIds
    };
    CatalogService.getItems(params).then((response) => {
        sliderInstance.removeAllSlides();

        response.items.forEach((item) => {
            sliderInstance.appendSlide(
                CatalogItem({
                    isSlider: true,
                    ...item
                })
            );
        });

        setTimeout(() => {
            sliderInstance.update();
            sliderInstance.slideTo(0);
        }, 2000);
    });
};

$('.index-popular-tabs__item').click(function () {
    if ($(this).hasClass('index-popular-tabs__item--active')) {
        return false;
    }
    const tab = $(this).attr('data-tab');

    // switch buttons
    $('.index-popular-tabs__item').removeClass('index-popular-tabs__item--active');
    $(this).addClass('index-popular-tabs__item--active');

    // switch tabs
    $('.index-popular-tab').hide();
    $(`.index-popular-tab--${tab}`).fadeIn();

    // switch select
    $(this).parent('.index-popular-tabs-select').slideToggle(200).siblings('.index-popular-select__value')
        .text($(this).text());

    // slider
    if (!indexPopularSliders[tab]) {
        createSlider(tab);

        let productIds = $(`.index-popular-tab--${tab}`).attr('data-products');
        if (productIds) {
            productIds = JSON.parse(productIds);
            refreshSlider(indexPopularSliders[tab], productIds);
        }
    }

    return true;
});

$('.index-popular-select__value').click(function () {
    $(this).siblings('.index-popular-tabs-select').slideToggle(200);
});

onDocumentReady(() => {
    $('.index-popular-tabs__item').first().click();
    if ($(window).width() < 768) {
        $('.index-popular-tabs-select .index-popular-tabs__item').first().click();
    }
});

StoreService.onChange(() => {
    indexPopularSliders.forEach((sliderInstance, tabId) => {
        let productIds = $(`.index-popular-tab--${tabId}`).attr('data-products');
        if (productIds) {
            productIds = JSON.parse(productIds);
            refreshSlider(sliderInstance, productIds);
        }
    });
});
